import styled from '@emotion/styled';
import { AppBar, Toolbar } from '@mui/material';
import ArrowLeft from '@/assets/icons/arrow-left.svg?react';
import {
  SIDE_BAR_WIDTH,
  HAMBURGER_BUTTON_SIZE,
  HEADER_GAP,
} from '@/layouts/MainLayout/utils/constants';
import Button from '@/components/atoms/Button/Button';
import { Theme } from '@mui/material/styles';
import { StyledAgioH1 } from '@/components/StyledSharedComponents/StyledTypography';

export const StyledHeader = styled(AppBar)<{ isDesktop: boolean; theme?: Theme }>`
  justify-content: center;
  width: ${({ isDesktop }) =>
    isDesktop
      ? '100%'
      : `calc(100% - ${HAMBURGER_BUTTON_SIZE} - (2 * ${HEADER_GAP}) - ${SIDE_BAR_WIDTH})`};
  height: 100%;
  background-color: ${({ theme }) => theme.palette.customSecondary.background.base};
  box-shadow: 0 1px 0 0 ${({ theme }) => theme.palette.customSecondary.neutral[500]};
`;

export const StyledBasicToolbar = styled(Toolbar)`
  padding: 15px 24px;
  height: 100%;
  overflow: auto;
  overflow-y: hidden;

  svg {
    flex-shrink: 0;
  }
`;

export const StyledPermittedToolbar = styled(StyledBasicToolbar)`
  justify-content: space-between;
  gap: 10px;
`;

export const StyledToolbarWrappingBackButton = styled(StyledBasicToolbar)`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const StyledToolbarWithSpacingForNestedBreadcrumb = styled(StyledBasicToolbar)`
  display: flex;
  gap: 5px;
`;

export const StyledTitleWithTooltipWrapper = styled.div`
  display: flex;
  gap: 5px;
`;

export const StyledCentredTitleWithTooltipWrapper = styled(StyledTitleWithTooltipWrapper)`
  align-items: center;
`;

export const StyledTitle = styled(StyledAgioH1)<{ theme?: Theme; blockGrow?: boolean }>`
  flex-grow: ${({ blockGrow }) => !blockGrow && 1};
  overflow: visible;
`;

export const StyledBackArrowIcon = styled(ArrowLeft)<{ theme?: Theme }>`
  color: ${({ theme }) => theme.palette.customSecondary.neutral[300]};
  width: 24px;
  height: 24px;
`;

export const StyledBackButton = styled(Button)<{ theme?: Theme }>`
  transition: transform 0.3s;

  svg {
    transition:
      color 0.3s,
      transform 0.3s;
  }

  :hover {
    transform: translateX(-5px);
    svg {
      color: ${({ theme }) => theme.palette.customSecondary.neutral[100]};
    }
  }
`;

export const StyledSummaryButton = styled(Button)<{ theme?: Theme }>`
  * {
    box-sizing: border-box;
  }

  display: flex;
  align-items: center;
  white-space: nowrap;
  padding: 5px 10px;
  --stroke-color: ${({ theme }) => theme.palette.customSecondary.neutral[100]};
  cursor: default;
  transition: box-shadow 0.3s;
  min-width: fit-content;

  :hover {
    box-shadow: 0 0 3px 3px ${({ theme }) => `${theme.palette.customSecondary.neutral[100]}40`};
  }
`;
